import { TextField } from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";

type NumberInputProps = {
  label: string;
  value: number;
  setValue: Dispatch<SetStateAction<number>>;
};

export const NumberInput = ({ label, value, setValue }: NumberInputProps) => {
  const [error, setError] = useState(value < 0);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(parseInt(e.target.value));
    setError(parseInt(e.target.value) < 0);
  };

  return (
    <TextField
      label={label}
      name={label}
      value={value}
      type="number"
      onChange={onChange}
      helperText={error && "Required"}
      sx={{ width: 96 }}
    />
  );
};
